import  { useEffect, useContext } from 'react'
import { fetchToken, CreateSessionId, moviesApi } from "../utils/index";
import alanBtn from '@alan-ai/alan-sdk-web'
import { ColorModeContext } from './../utils/ToggleDarkmode';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { SearchMovie, selectGenreOrCategory } from '../features/currentGenreOrCategory';
const useAlan = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const { setMode } = useContext(ColorModeContext);

    useEffect(() => {
        alanBtn({
            key: process.env.REACT_APP_ALAN_KEY,
            onCommand: ({command, mode,genreOrCategory, genres, query}) => {
               
                if (command === 'ChooseGenre') {
                
                    console.log('command', command);
                    const foundGenre = genres.find((genre) => genre.name.toLowerCase() === genreOrCategory.toLowerCase());

                    if (foundGenre) {
                        history.push('/')
                        dispatch(selectGenreOrCategory(foundGenre.id));
                    }
                    else {
                        const category = genreOrCategory.startsWith('top') ? 'top_rated' : genreOrCategory
                        history.push('/')
                        dispatch(selectGenreOrCategory(category));
                    }
                }
                else if (command === 'changeMode') {
                    if (mode === 'light')
                    {
                        setMode('light') 
                    }
                    else {
                        setMode('dark')
                    }
              }

             else if (command === 'login') {
                    fetchToken();
                }
                else if (command === 'logout') {
                    localStorage.clear();
                    window.location.href = '/';
                }
                else if (command === 'search') {
                    dispatch(SearchMovie(query))
                }
            }
        });
      }, []);
}

export default useAlan